import React from 'react';
import _ from 'lodash';

function PwdForm({
  pwd,
  onBlur,
  onPwdChange,
  pwdCheck,
  onPwdReset,
  handleMouseDown,
  rePwd,
  onRePwdChange,
  onRePwdReset
}) {
  return (
    <div className="item">
      <div className="input_title">비밀번호</div>
      <div className="input_cont h56">
        <ul>
          <li>
            <div className="input_box white_box">
              <input
                type="password"
                name="pwd"
                placeholder="영문, 숫자, 특수문자를 조합하여 8자 이상 입력해 주세요."
                value={pwd}
                onBlur={onBlur}
                onChange={onPwdChange}
              />
              <div className="r_area">
                {
                  (_.isEqual(pwdCheck, 'success') && !_.isEmpty(pwd)) && (
                    <img src="../static/images/icon/ic_check.svg" alt="" />
                  )
                }
                <button
                  type="button"
                  onClick={onPwdReset}
                  onMouseDown={handleMouseDown}
                >
                  {
                    (_.isEmpty(pwdCheck) && !_.isEmpty(pwd)) && (
                      <img src="../static/images/icon/input_delete_40.svg" alt="" />
                    )
                  }
                  {
                    (_.isEqual(pwdCheck, 'pattern') && !_.isEmpty(pwd)) && (
                      <img src="../static/images/icon/ic_error.svg" alt="" />
                    )
                  }
                </button>
              </div>
            </div>
            {
              (_.isEqual(pwdCheck, 'pattern') && !_.isEmpty(pwd)) && (
                <div className="info_txt red">영문, 숫자, 특문 포함 8글자 이상이어야 합니다.</div>
              )
            }
          </li>
          <li>
            <div className="input_box white_box">
              <input
                type="password"
                name="rePwd"
                placeholder="비밀번호를 동일하게 한 번 더 입력해 주세요."
                value={rePwd}
                onBlur={onBlur}
                onChange={onRePwdChange}
              />
              <div className="r_area">
                {
                  (pwd === rePwd && !_.isEmpty(rePwd)) && (
                    <img src="../static/images/icon/ic_check.svg" alt="" />
                  )
                }
                <button
                  type="button"
                  onClick={onRePwdReset}
                  onMouseDown={handleMouseDown}
                >
                  {
                    (!_.isEqual(pwd, rePwd) && !_.isEqual(pwdCheck, 'diff') && !_.isEmpty(rePwd)) && (
                      <img src="../static/images/icon/input_delete_40.svg" alt="" />
                    )
                  }
                  {
                    (!_.isEqual(pwd, rePwd) && _.isEqual(pwdCheck, 'diff') && !_.isEmpty(rePwd)) && (
                      <img src="../static/images/icon/ic_error.svg" alt="" />
                    )
                  }
                </button>
              </div>
            </div>
            {
              (_.isEqual(pwdCheck, 'diff') && !_.isEmpty(rePwd)) && (
                <div className="info_txt red">입력한 비밀번호와 재입력한 비밀번호가 일치하지 않습니다.</div>
              )
            }
          </li>
        </ul>
      </div>
    </div>
  );
}

export default PwdForm;